module.exports = __webpack_public_path__ + "img/10879_L.dc63c3d6.png";